import React from "react";
import { Route, Routes, useLocation, Outlet } from "react-router-dom";

import useLayouts from "../../layouts";
import useControllers from "../../../controllers";

import SettingsView from "./Views";
import SettingsCreate from "./Create";

const SettingsLayout = () => {
  const { PrivateContentLayout } = useLayouts();
  const { useScreenHooks } = useControllers();
  const { useSettings } = useScreenHooks();
  const { handleBack, header, headerKey } = useSettings();
  
  const location = useLocation();
  const isExact = location.pathname === "/configuracion/settings";

  return (
    <PrivateContentLayout
      breadcrumbsList={header[headerKey]}
      handleBack={handleBack}
      showBack={!isExact}
      title="Settings"
    >
      <Outlet />
    </PrivateContentLayout>
  );
};

const Settings = () => {
  return (
    <Routes>
      <Route path="/" element={<SettingsLayout />}>
        <Route index element={<SettingsView />} />
        <Route path="creacion" element={<SettingsCreate />} />
        <Route path="editar/:newId" element={<SettingsCreate />} />
      </Route>
    </Routes>
  );
};

export default Settings;
